__turbopack_context__.v({
  "button": "Button-module-scss-module__f5AQIa__button",
  "button-brand": "Button-module-scss-module__f5AQIa__button-brand",
  "button-dark": "Button-module-scss-module__f5AQIa__button-dark",
  "button-disabled": "Button-module-scss-module__f5AQIa__button-disabled",
  "button-expand": "Button-module-scss-module__f5AQIa__button-expand",
  "button-fit": "Button-module-scss-module__f5AQIa__button-fit",
  "button-gray": "Button-module-scss-module__f5AQIa__button-gray",
  "button-green": "Button-module-scss-module__f5AQIa__button-green",
  "button-lg": "Button-module-scss-module__f5AQIa__button-lg",
  "button-light": "Button-module-scss-module__f5AQIa__button-light",
  "button-md": "Button-module-scss-module__f5AQIa__button-md",
  "button-orange": "Button-module-scss-module__f5AQIa__button-orange",
  "button-red": "Button-module-scss-module__f5AQIa__button-red",
  "button-sm": "Button-module-scss-module__f5AQIa__button-sm",
});
